var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeraldine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198 353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcdbbc;\n      }\n\n      .cls-2 {\n        fill: #825c41;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        fill: none;\n      }\n\n      .cls-3, .cls-5, .cls-6 {\n        stroke-width: 3px;\n      }\n\n      .cls-3, .cls-5, .cls-6, .cls-7 {\n        stroke-linecap: round;\n      }\n\n      .cls-3, .cls-5, .cls-7 {\n        stroke-linejoin: round;\n      }\n\n      .cls-3, .cls-6 {\n        stroke: #000;\n      }\n\n      .cls-4 {\n        stroke: #42c763;\n        stroke-width: 2px;\n      }\n\n      .cls-4, .cls-6 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-8 {\n        fill: #015e59;\n      }\n\n      .cls-9 {\n        fill: #faf9f8;\n      }\n\n      .cls-10 {\n        fill: #f8d9bc;\n      }\n\n      .cls-11 {\n        fill: #414a4c;\n      }\n\n      .cls-12 {\n        fill: #66452e;\n      }\n\n      .cls-13 {\n        fill: #eeb68c;\n      }\n\n      .cls-14 {\n        fill: #063842;\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-17 {\n        fill: #e6eef2;\n      }\n\n      .cls-18 {\n        fill: #fff;\n      }\n\n      .cls-19 {\n        fill: #42c763;\n      }\n\n      .cls-5, .cls-7 {\n        stroke: #eeb68c;\n      }\n\n      .cls-20 {\n        fill: #0d5359;\n      }\n\n      .cls-21 {\n        fill: #63e06b;\n      }\n\n      .cls-22 {\n        fill: #8ff584;\n      }\n\n      .cls-7 {\n        stroke-width: 2.32px;\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M93.68,152.34h20.26c9.59,0,17.37,7.78,17.37,17.37v7.37c0,3.49-2.83,6.32-6.32,6.32h-42.37c-3.49,0-6.32-2.83-6.32-6.32v-7.37c0-9.59,7.78-17.37,17.37-17.37Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 95.42,
    y: 93.58,
    width: 22.72,
    height: 31.83,
    rx: 11.36,
    ry: 11.36
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 132.39,
    y: 93.58,
    width: 22.72,
    height: 31.83,
    rx: 11.36,
    ry: 11.36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 100,
    cy: 309,
    rx: 68,
    ry: 28
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.1,
    y: 151.41,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(243.52 356.11) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.1,
    y: 187.34,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(243.52 427.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 127.44,
    cy: 232.61,
    r: 14.34
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 103.81,
    y: 202.29,
    width: 22.17,
    height: 65.8,
    rx: 11.09,
    ry: 11.09,
    transform: "translate(229.79 470.37) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.98,300v-42.97c0-6.12-4.96-11.09-11.09-11.09h0c-6.12,0-11.09,4.96-11.09,11.09v42.97h22.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 103.81,
    y: 286.57,
    width: 22.17,
    height: 13.32,
    transform: "translate(229.79 586.46) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M108.83,298.61h33.28v13.13h-30.18c-4.48,0-8.11-3.63-8.11-8.11h0c0-2.77,2.25-5.02,5.02-5.02Z",
    transform: "translate(245.91 610.35) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M103.81,190.56h30.4v43.62h-16.02c-7.93,0-14.38-6.44-14.38-14.38v-29.25h0Z",
    transform: "translate(238.02 424.75) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 103.81,
    y: 224.91,
    width: 32.77,
    height: 9.28,
    transform: "translate(240.39 459.09) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 83.41,
    y: 179.84,
    width: 40.79,
    height: 21.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 83.41,
    y: 181.94,
    width: 40.79,
    height: 6.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.81,19.57h0c-26.27,0-49.23,17.73-55.88,43.14l-15.22,58.2c-4.16,15.89,7.84,31.43,24.26,31.43h33.52c46.85,0,81.05-44.29,69.2-89.62h0c-6.65-25.42-29.61-43.14-55.88-43.14Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M93.68,152.34h20.26c9.59,0,17.37,7.78,17.37,17.37v7.37c0,3.49-2.83,6.32-6.32,6.32h-42.37c-3.49,0-6.32-2.83-6.32-6.32v-7.37c0-9.59,7.78-17.37,17.37-17.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M87.76,150.89h32.11v.07c0,6.28-5.1,11.38-11.38,11.38h-9.34c-6.28,0-11.38-5.1-11.38-11.38v-.07h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M84.35,73.19h71.99v40.39c0,21.39-17.37,38.76-38.76,38.76h-18.94c-13.06,0-23.66-10.6-23.66-23.66v-46.12c0-5.17,4.2-9.37,9.37-9.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.13,55.62h25.08c15.53,0,28.14,12.61,28.14,28.14v35.44c0,18.07-14.67,32.74-32.74,32.74h-15.88c-18.07,0-32.74-14.67-32.74-32.74v-35.44c0-15.53,12.61-28.14,28.14-28.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.77,
    y: 137.36,
    width: 24.07,
    height: 17.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.41,47h17.74c21.35,0,38.68,17.33,38.68,38.68v1.28h-32.91c-12.98,0-23.51-10.53-23.51-23.51v-16.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M83.41,193.26h40.79v8.88c0,7.41-6.01,13.42-13.42,13.42h-13.95c-7.41,0-13.42-6.01-13.42-13.42v-8.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M130.4,143.99c-7.78,2.53-16.13-1.72-18.67-9.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M126.9,113.42l5.97,16.86c.51,1.44-.56,2.96-2.09,2.96h-2.66c-1.65,0-2.99-1.34-2.99-2.99v-16.52c0-1.02,1.43-1.27,1.77-.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 86.51,
    y: 193.26,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 92.89,
    y: 193.26,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 99.27,
    y: 193.26,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 105.65,
    y: 193.26,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 112.03,
    y: 193.26,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 118.42,
    y: 193.26,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.82,
    y: 213.59,
    width: 22.17,
    height: 65.8,
    rx: 11.09,
    ry: 11.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.99,268.33c0-6.12-4.96-11.09-11.09-11.09s-11.09,4.96-11.09,11.09v41.58l22.17,10.16v-51.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M87.79,199.18h23.84v43.62h-38.21v-29.25c0-7.93,6.44-14.38,14.38-14.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 71.04,
    y: 233.53,
    width: 43.85,
    height: 9.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 82.82,
    y: 297.88,
    width: 22.17,
    height: 13.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M87.84,309.92h33.28v13.13h-30.18c-4.48,0-8.11-3.63-8.11-8.11h0c0-2.77,2.25-5.02,5.02-5.02Z",
    transform: "translate(203.93 632.96) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M116.49,203.33h5.03v9.01c0,2.78-2.26,5.03-5.03,5.03h0v-14.05h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 104.78,
    y1: 244.29,
    x2: 104.78,
    y2: 295.76
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 95.42,
    y: 93.58,
    width: 22.72,
    height: 31.83,
    rx: 11.36,
    ry: 11.36
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 102.86,
    y: 102.7,
    width: 12.63,
    height: 21.18,
    rx: 6.31,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 101.89,
    y: 99.36,
    width: 6.91,
    height: 12.59,
    rx: 3.45,
    ry: 3.45
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.42,105.14v-.2c0-6.27,5.09-11.36,11.36-11.36h0c6.27,0,11.36,5.09,11.36,11.36v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 91.63,
    y1: 101.2,
    x2: 95.66,
    y2: 102.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 93.17,
    y1: 96.89,
    x2: 96.94,
    y2: 98.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 132.39,
    y: 93.58,
    width: 22.72,
    height: 31.83,
    rx: 11.36,
    ry: 11.36
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 139.83,
    y: 102.7,
    width: 12.63,
    height: 21.18,
    rx: 6.31,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 138.86,
    y: 99.36,
    width: 6.91,
    height: 12.59,
    rx: 3.45,
    ry: 3.45
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M132.39,105.14v-.2c0-6.27,5.09-11.36,11.36-11.36h0c6.27,0,11.36,5.09,11.36,11.36v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 159.07,
    y1: 101.2,
    x2: 155.04,
    y2: 102.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 157.54,
    y1: 96.89,
    x2: 153.76,
    y2: 98.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.15,117.75h0c6.39,0,11.57,5.19,11.57,11.57v2.04h-10.13c-3.24,0-5.87-2.63-5.87-5.87v-3.32c0-2.44,1.98-4.43,4.43-4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.82,117.75h9.23v5.54c0,4.46-3.62,8.08-8.08,8.08h0c-3.2,0-5.8-2.6-5.8-5.8v-3.16c0-2.57,2.09-4.65,4.65-4.65Z",
    transform: "translate(300.23 249.12) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.87,
    y: 167.8,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.87,
    y: 203.73,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 77.86,
    cy: 248.99,
    r: 14.34
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "111.62 233.53 111.62 220.2 116.49 220.2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeraldine1);
export default __webpack_public_path__ + "static/media/geraldine_1.62d60566900479f3b4ac7103d7b87725.svg";
export { ForwardRef as ReactComponent };